<template>
  <div>
    <h2>Сделки</h2>

    <div>
      <b-tabs pills>
        <b-tab
          v-for="(tab, key) in tabs"
          :key="key"
          :active="currentTabKey === key"
        >
          <template slot="title">
            <span :id="`popover-target-deals-tab-${key}`">Вкладка №{{ key + 1 }}</span>
            <b-popover
              v-if="tab.filterData.query
              || tab.filterData.tags.length > 0
              || tab.filterData.created_from
              || tab.filterData.created_to"
              :target="`popover-target-deals-tab-${key}`"
              triggers="hover"
              placement="bottom"
            >
              <div class="font-weight-bold">Активные фильтры:</div>
              <div v-if="tab.filterData.query">Название: {{ tab.filterData.query }}</div>
              <div v-if="tab.filterData.tags.length > 0">
                <span>Тэги:</span>
                <b-badge v-for="tag in tab.filterData.tags" :key="tag" class="ml-1">{{ tag.title }}</b-badge>
              </div>
              <div v-if="tab.filterData.created_from">Создано от: {{ tab.filterData.created_from }}</div>
              <div v-if="tab.filterData.created_to">Создано до: {{ tab.filterData.created_to }}</div>
            </b-popover>
          </template>
          <div class="mt-4">
            <b-button variant="danger" class="float-right" @click="closeTab(key)">
              Закрыть вкладку
            </b-button>
            <deals
              :tabKey="key"
              :filterData="tab.filterData"
              @filterUpdate="filterUpdate"
            ></deals>
          </div>
        </b-tab>

        <!-- New Tab Button (Using tabs-end slot) -->
        <template #tabs-end>
          <b-nav-item role="presentation" @click.prevent="newTab" href="#"><b>+</b></b-nav-item>
        </template>

        <!-- Render this if no tabs -->
        <template #empty>
          <div class="text-center text-muted">
            Нет открытых вкладок<br>
            Чтобы открыть новую вкладку, нажмите <b>+</b> выше.
          </div>
        </template>
      </b-tabs>
    </div>
  </div>
</template>

<script>
import Deals from "../views/Deals"

export default {
  name: "DealsLayout",
  components: {Deals},
  data() {
    return {
      currentTabKey: 0,
      tabs: []
    }
  },
  created() {
    const loadedTabs = JSON.parse(localStorage.getItem('dealsTabs'))

    if (loadedTabs !== null && loadedTabs.length > 0) {
      this.tabs = loadedTabs
    } else {
      this.tabs.push(this.initTabData())
    }
  },
  mounted() {
  //
  },
  watch: {
    'tabs': {
      handler: function (data) {
        if (data) {
          localStorage.setItem('dealsTabs', JSON.stringify(data))
        } else {
          this.tabs.push(this.initTabData())
        }
      },
      immediate: false,
      deep: true
    },
  },
  methods: {
    initTabData() {
      return {
        filterData: {
          query: null,
          status: null,
          tags: [],
          created_from: null,
          created_to: null
        }
      }
    },
    closeTab(key) {
      this.tabs.splice(key, 1)
    },
    newTab() {
      this.tabs.push(this.initTabData())
    },
    filterUpdate(key, data) {
      this.tabs[key].filterData = data;
    }
  }
}
</script>

<style scoped lang="scss">

</style>
